export type DbState<T> = {
    toArray: () => T[] | undefined,
    get: (itemId: number | string) => T | undefined
    find: (predicate: (value: T, index: number, obj: T[]) => unknown) => T | undefined
    findIndex: (predicate: (value: T, index: number, obj: T[]) => unknown) => number | undefined
    filter: (predicate: (value: T, index: number, obj: T[]) => unknown) => T[]
    some: (predicate: (value: T, index: number, array: T[]) => unknown) => boolean
    map: <U>(callbackfn: (value: T, index: number, array: T[]) => U) => U[]
    forEach: (callbackfn: (value: T, index: number, array: T[]) => void) => void
    length: number
    put: (updatedItem: T) => void
    bulkPut: (items: T[]) => void
    remove: (itemId: number | string) => void
    bulkRemove: (itemIds: (number | string)[]) => void
    set: (items: T[]) => void
    isReady: () => boolean
}

export const defaultDbState = <T>(data?: T[]): DbState<T> => ({
    toArray: () => data,
    get: () => undefined,
    find: () => undefined,
    findIndex: () => undefined,
    filter: () => [],
    some: () => false,
    map: () => [],
    forEach: () => undefined,
    length: 0,
    put: () => { },
    bulkPut: () => { },
    remove: () => { },
    bulkRemove: () => { },
    set: () => { },
    isReady: () => false
})



